import { GenericStepHeader } from "@/components/PaymentFlow/Steps/StepHeader";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function StepHeader({
  currentStep,
  setCurrentStep,
}: Readonly<{
  currentStep: number;
  setCurrentStep: (step: number) => void;
}>) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleModalClose = () => {
    navigate({ to: "/donor-profile", search: { page: "circles" } });
  };

  const steps = [t("circle.circle"), t("circle.details")];

  return (
    <GenericStepHeader
      steps={steps}
      currentStep={currentStep}
      handleModalClose={handleModalClose}
      setCurrentStep={setCurrentStep}
    />
  );
}
